import React from 'react';
import styled, { css } from 'styled-components';

import mq from '../../../styles/breakpoints';
import Colors from '../../../styles/colors';

interface Props {
  number: number;
}

const NumberIcon = ({ number = 1 }: Props) => (
  <Container>
    <NumberWrapper>
      <Number>{number}</Number>
    </NumberWrapper>
  </Container>
);

export default NumberIcon;

const Container = styled.div`
  height: 46px;
  position: relative;
  width: 46px;
`;

const NumberCircle = css`
  background: linear-gradient(205.5deg, #009695 12.49%, #005e5d 87.51%);
  border-radius: ${({ theme }) => theme.radiuses.XXL};
  content: '';
  height: 28px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 28px;

  ${mq.from.breakpoint.M`
    height: 42px;
    width: 42px;
  `}

  ${mq.from.breakpoint.L`
    height: 46px;
    width: 46px;
  `}
`;

const NumberWrapper = styled.div`
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);

  &:before {
    ${NumberCircle};
  }
`;

const Number = styled.div`
  align-items: center;
  background: linear-gradient(225deg, #00c4bb 15.52%, #009185 87.26%);
  border-radius: ${({ theme }) => theme.radiuses.XXL};
  color: ${Colors.white};
  display: flex;
  flex-shrink: 0;
  font-family: ${({ theme }) => theme.fontRegular};
  font-size: 16px;
  font-weight: 900;
  height: 24px;
  justify-content: center;
  line-height: 1;
  position: relative;
  width: 24px;

  ${mq.from.breakpoint.M`
    font-size: 24px;
    height: 36px;
    width: 36px;
  `}

  ${mq.from.breakpoint.L`
    height: 40px;
    width: 40px;
  `}
`;
